<template>
  <MainLayout :title="$t('pages.performance')">
    <template slot="leftElements">
      <ChartFilters page="performance" />
    </template>
    <template slot="rightElements">
      <VsDatePicker v-if="selectedDateRange" :selectedDate="selectedDateRange" @changedDate="changedDate" />
    </template>
    <div slot="content">
      <PerformanceViews />
    </div>
  </MainLayout>
</template>

<script>
import MainLayout from "@/layouts/Main";
import ChartFilters from "@/components/shared/ChartFilters/Index";
import PerformanceViews from "@/components/performance/Index";
import { mapGetters, mapActions } from "vuex";

export default {
  components: {
    MainLayout,
    ChartFilters,
    PerformanceViews,
  },
  computed: {
    ...mapGetters({
      selectedDateRange: "performance/selectedDateRange",
    }),
  },
  created() {
    if (!this.selectedDateRange) {
      this.initDateRange();
    }
  },
  methods: {
    ...mapActions("performance", ["initDateRange", "setDateRange"]),
    changedDate(changedDate) {
      this.setDateRange({
        startDate: changedDate.start,
        endDate: changedDate.end,
      });
    },
  },
};
</script>
